export default __webpack_public_path__ + "static/media/phone-ok.9a04d045.svg";